export default __webpack_public_path__ + "static/media/est-vilarinho.8a9efee0.png";